/* eslint-disable no-console */
import { signIn, signOut, getCurrentUser, fetchAuthSession, confirmSignIn } from 'aws-amplify/auth'

export const getToken = async () => {
  try {
    const session = await fetchAuthSession()
    const idToken = session?.tokens?.idToken?.toString()
    if (!idToken) {
      throw new Error('No idToken')
    }
    return idToken
  } catch (error) {
    console.error('[Amplify] getToken:', error)
    return undefined
  }
}

export const fetchIsUserAuthenticated = async () => {
  try {
    const [user, session] = await Promise.all([getCurrentUser(), fetchAuthSession()])
    const isValid = user && session.tokens
    return isValid
  } catch (error) {
    return false
  }
}

export const handleSignIn = async (userAlias) => {
  const signInOutput = await signIn({
    username: userAlias,
    options: {
      authFlowType: 'CUSTOM_WITHOUT_SRP',
    },
  })
  return signInOutput.isSignedIn
}

export const handleConfirmSignIn = async (code) => {
  const { isSignedIn, nextStep } = await confirmSignIn({ challengeResponse: code })
  console.log(JSON.stringify({ isSignedIn, nextStep }))
  return isSignedIn
}

export const handleSignOut = async () => {
  await signOut()
  return true
}
